import React from "react";
import { AppProvider } from "@context/AppContext";
import { navigate } from "gatsby";

import "./src/styles/global.css";
import "./src/styles/cookies.css";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined") {
    const previouslySet = sessionStorage.getItem("romvimzahcpdfk-pw") === "true";
    const queryParams = new URLSearchParams(location.search);
    const edResourceRoute = queryParams.get("romvimzahcpdfk-pw") === "true";

    if (location.pathname === "/resources" && !previouslySet && !edResourceRoute) {
      navigate("/");
    }
  }
};
